import { useEffect, useRef, useState } from 'react'

import { Text, TextProps, Tooltip } from '@chakra-ui/react'

interface OverflownTextlIProps extends TextProps {
  children?: React.ReactNode
}

export const OverflowText = ({ children, ...props }: OverflownTextlIProps) => {
  const ref = useRef(null)
  const [isOverflown, setIsOverflown] = useState(false)
  useEffect(() => {
    const element = ref.current!
    setIsOverflown(element.scrollWidth > element.clientWidth)
  }, [])

  return (
    <Tooltip hasArrow isDisabled={!isOverflown} label={children}>
      <Text isTruncated position='relative' ref={ref} {...props}>
        {children}
      </Text>
    </Tooltip>
  )
}
